export enum ACTIONS {
    PROFILE_SUCCESS = 'PROFILE_SUCCESS',
    PROFILE_LOADING = 'PROFILE_LOADING',
    PROFILE_ERROR = 'PROFILE_ERROR',
    CLAIMS_SUCCESS = 'CLAIMS_SUCCESS',
    CLAIMS_LOADING = 'CLAIMS_LOADING',
    CLAIMS_ERROR = 'CLAIMS_ERROR'
} 

const defaultProfile ={
    profile: null,
    loading: false,
    error: false
};

export const getProfile = (state = defaultProfile, action) => {
    switch (action.type) {
        case ACTIONS.PROFILE_LOADING: 
            return { loading: true, error: false};
        case ACTIONS.PROFILE_SUCCESS: 
            return { profile: action.data, loading: false, error: false};
        case ACTIONS.PROFILE_ERROR: 
            return { loading: false, error: true };
        default:
            return {...state}
    }
}

const defaultClaims ={
    claims: [],
    isNoClaims: false,
    loading: false,
    error: false,
};

export const getClaims = (state = defaultClaims, action) => {
    switch (action.type) {
        case ACTIONS.CLAIMS_LOADING: 
            return { loading: true, error: false};
        case ACTIONS.CLAIMS_SUCCESS: 
            return { claims: action.data, loading: false, error: false};
        case ACTIONS.CLAIMS_ERROR: 
            return { loading: false, error: true };
        default:
            return {...state}
    }
}